import { useCallback } from 'react'
import IconButton from '@mui/material/IconButton'
import MenuIcon from '@mui/icons-material/Menu'
import useAppStore from '$appStore'

/**
 * The window event the React topbar dispatches to ask the still-AngularJS app
 * shell to toggle its sidenav. Handled in app/directives/sidenav/
 * sidenav.directive.js.
 */
const TOGGLE_SIDEBAR_EVENT = '@@loaded/reactToggleSidebar'

/**
 * The topbar's small-screen-only left button that allows the sidenav to be
 * toggled open / closed.
 *
 * Hidden on desktop layout.
 */
const TopbarMobileButton = () => {
  const handleToggleSidebar = useCallback(() => {
    window.dispatchEvent(new CustomEvent(TOGGLE_SIDEBAR_EVENT))
  }, [])

  const activeCompany = useAppStore((store) => store.activeCompany)

  if (!activeCompany) {
    // We don't have an active company in the case a user has just signed up for
    // a Loaded account and haven't yet created a venue (or been invited to one).
    // In this case the hamburger menu that shows on a mobile device has no
    // active venue to show any content for, so we avoid showing it altogether.
    return null
  }

  return (
    <IconButton
      aria-label="Toggle navigation"
      onClick={handleToggleSidebar}
      sx={{
        display: 'inline-flex',
        '@media (min-width: 1200px)': {
          display: 'none',
        },
        color: (theme) => theme.app.headerTextColor,
      }}
    >
      <MenuIcon />
    </IconButton>
  )
}

export default TopbarMobileButton
